<div class="main no-padding">

  <header-menu></header-menu>

  <div class="colab-manager-wrapper"> 
    <div class="content colab-manager-content no-padding">
      <simulator-component></simulator-component>
    </div>
  </div>
</div>